import React from 'react';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 *  L'accueil
 * @param {props} props
 * @return {JSX}
 */
function EmployeUpdateView(props) {
  return (
    <MDBContainer className="modal" fluid >
      <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content" style={{marginTop: '100px'}}>
        <MDBCol col="12">
          <MDBCard
            className="bg-dark text-white my-5 mx-auto align-items-center"
            style={{borderRadius: '1rem', maxWidth: '800px'}}>
            <span className="employe-close" onClick={props.closeModal} style={{marginRight: '20px', marginTop: '10px'}}>
                &times;
            </span>
            <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>
              {props.isUpdate ? 'Modifier l\'employé' : 'Ajouter un employé'}
            </h2>
            <MDBCardBody className="mx-auto w-100 employer-padding">
              <div>
                <label className="labechantier">Nom de l'employé</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom de l'employé"
                  name="name"
                  value={props.form.name}
                  onChange={props.handleChange} />
                {props.errors && props.errors.name && (
                  <span className="error">{props.errors.name}</span>
                )}
              </div>
              <label className="labechantier" style={{marginTop: '8px'}}>Courriel</label>
              <input
                type="text"
                className="form-control"
                placeholder="Courriel"
                name="email"
                value={props.form.email}
                onChange={props.handleChange} />
              {props.errors && props.errors.emailRequis && (
                <span className="error">{props.errors.emailRequis}</span>
              )}
              {props.errors && props.errors.emailUsed && (
                <span className="error">{props.errors.emailUsed}</span>
              )}

              <label className="text-white" style={{marginTop: '10px'}}>Heures de la semaine &#40;régulier&#41;:</label>
              <div className="sameLineContainer">
                <div className="sameLine">
                  <input
                    type="tel"
                    min="0"
                    name="default_hours"
                    className="form-control"
                    value={isNaN(parseInt(props.form.default_hours)) ? '' : parseInt(props.form.default_hours)}
                    onChange={props.handleChange} />
                </div>
                <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px', paddingRight: '15px'}}>
                    h
                </div>
                <div className="sameLine">
                  <input
                    min="0"
                    type="tel"
                    name="default_minutes"
                    className="form-control"
                    value={isNaN(parseInt(props.form.default_minutes)) ? '' : parseInt(props.form.default_minutes)}
                    onChange={props.handleChange} />
                </div>
                <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px'}}>
                    min
                </div>

              </div>
              {props.errors && props.errors.default_hours && (
                <span className="error">{props.errors.default_hours}</span>
              )}
              {props.errors && props.errors.default_minutes && (
                <span className="error">{props.errors.default_minutes}</span>
              )}

              <div className="app" style={{textAlign: 'center', marginTop: '20px', marginBottom: '10px'}} >
                <label className="labechantier">Administrateur?</label>
                <div className="toggle-switch">
                  <div>
                    <input
                      id="toggle-employe"
                      type="checkbox"
                      name="is_admin"
                      defaultChecked={props.form.is_admin}
                      onChange={props.handleCheckboxChange} />
                    <label htmlFor="toggle-employe"></label>
                  </div>
                </div>
              </div>
              <label className="labechantier" style={{marginTop: '10px'}}>
                {props.isUpdate ?
                      'Laissez vide si vous ne voulez pas changer le mot de passe' :
                      ''}
              </label>
              <input
                style={{marginTop: '10px'}}
                type="text"
                className="form-control"
                placeholder="Mot de passe"
                name="password"
                value={props.form.password}
                onChange={props.handleChange} />
              {props.errors && props.errors.password && (
                <span className="error">{props.errors.password}</span>
              )}
              <input
                style={{marginTop: '15px'}}
                type="text"
                className="form-control"
                placeholder="Confirmer le mot de passe"
                name="confirmPassword"
                value={props.form.confirmPassword}
                onChange={props.handleChange} />
              {props.errors && props.errors.confirmPassword && (
                <span className="error">{props.errors.confirmPassword}</span>
              )}
              <div>
                {props.errors && props.errors.samePassword && (
                  <span className="error">{props.errors.samePassword}</span>
                )}
              </div>
              <Button
                color="white"
                size="lg"
                style={{
                  color: 'white',
                  fontSize: 'calc(10px + 2vmin)',
                  backgroundColor: '#363E46',
                  border: 'none',
                  width: '100%',
                }}
                onClick={() => props.handleSubmit()}>
                  Enregistrer
              </Button>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default EmployeUpdateView;
